/* Partner attribution is separate from Shopify discount codes.
   ?ref=MARTI is stored as davai_affiliate and cart attribute affiliate=marti
   even when checkout applies a different automatic discount. */
(function () {
  var STORAGE_KEY = 'davai_affiliate';
  var ATTRIBUTE = 'affiliate';
  var CODE_PATTERN = /^[a-z0-9][a-z0-9_-]{0,63}$/;

  if (window.__davaiAffiliate) return;
  window.__davaiAffiliate = true;

  function normalize(value) {
    if (typeof value !== 'string') return '';
    var code = value.trim().toLowerCase();
    if (!CODE_PATTERN.test(code)) return '';
    return code;
  }

  function readStorage() {
    try {
      return normalize(window.localStorage.getItem(STORAGE_KEY) || '');
    } catch (error) {
      return '';
    }
  }

  function writeStorage(code) {
    try {
      window.localStorage.setItem(STORAGE_KEY, code);
    } catch (error) {}
  }

  function readRef() {
    try {
      return normalize(new URLSearchParams(window.location.search).get('ref') || '');
    } catch (error) {
      return '';
    }
  }

  var fromUrl = readRef();
  if (fromUrl) writeStorage(fromUrl);

  var affiliate = fromUrl || readStorage();
  if (!affiliate) return;

  var nativeFetch = window.fetch.bind(window);
  var ready = Promise.resolve();

  function updateUrl() {
    var routes = window.routes || {};
    return routes.cart_update_url || '/cart/update.js';
  }

  function isCartMutation(url) {
    try {
      var path = new URL(url, window.location.origin).pathname;
      return /\/cart\/(?:add|change|update)(?:\.js)?$/.test(path);
    } catch (error) {
      return false;
    }
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function attachAffiliate(body) {
    if (!body) return body;

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      body.set('attributes[' + ATTRIBUTE + ']', affiliate);
      return body;
    }

    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      body.set('attributes[' + ATTRIBUTE + ']', affiliate);
      return body;
    }

    if (typeof body !== 'string') return body;

    var trimmed = body.trim();
    if (trimmed.charAt(0) === '{') {
      try {
        var data = JSON.parse(trimmed);
        if (!data || typeof data !== 'object' || Array.isArray(data)) return body;
        var attributes = data.attributes;
        if (!attributes || typeof attributes !== 'object' || Array.isArray(attributes)) attributes = {};
        attributes[ATTRIBUTE] = affiliate;
        data.attributes = attributes;
        return JSON.stringify(data);
      } catch (error) {
        return body;
      }
    }

    if (trimmed.indexOf('=') !== -1) {
      var params = new URLSearchParams(trimmed);
      params.set('attributes[' + ATTRIBUTE + ']', affiliate);
      return params.toString();
    }

    return body;
  }

  function cartAttributeMissing(cart) {
    if (!cart || typeof cart !== 'object') return false;
    if (!Object.prototype.hasOwnProperty.call(cart, 'item_count')) return false;
    var attributes = cart.attributes || {};
    return attributes[ATTRIBUTE] !== affiliate;
  }

  function syncAttribute() {
    return nativeFetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { affiliate: affiliate } }),
    })
      .then(function (response) {
        return response.json().catch(function () {
          return null;
        });
      })
      .catch(function () {
        return null;
      });
  }

  function queueSync() {
    ready = syncAttribute();
    return ready;
  }

  window.fetch = function (input, init) {
    if (!init || !init.body || !isCartMutation(requestUrl(input))) {
      return nativeFetch(input, init);
    }

    var next = {};
    for (var key in init) {
      if (Object.prototype.hasOwnProperty.call(init, key)) next[key] = init[key];
    }
    next.body = attachAffiliate(init.body);

    return ready.then(function () {
      return nativeFetch(input, next);
    });
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cart = event && event.cartData;
      if (!cartAttributeMissing(cart)) return;
      queueSync();
    });
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) queueSync();
  });

  queueSync();
})();
